<template>
  <div class="testimonial-wrap pb-100" id="clientes">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title text-center style1 mb-30">
            <h2>Empresas que Confían en Nuestros Servicios</h2>
          </div>
        </div>
      </div>

      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="testimonial-bg testimonial-bg-1 bg-f"></div>
        </div>

        <div class="col-lg-6">
          <Carousel
            :autoplay="5000"
            :wrap-around="true"
            pause-autoplay-on-hover
            class="testimonial-slider-two style2"
          >
            <Slide v-for="testimonial in testimonials" :key="testimonial.id">
              <div class="testimonial-card style5">
                <div class="quote-icon">
                  <i class="flaticon-quote-1"></i>
                </div>
                <p class="client-quote">
                  {{ testimonial.shortDesc }}
                </p>
                <div class="client-info-area">
                  <div class="client-info">
                    <h3>{{ testimonial.name }}</h3>
                    <span>{{ testimonial.designation }}</span>
                  </div>
                  <ul class="ratings list-style">
                    <li><i class="ri-star-fill"></i></li>
                    <li><i class="ri-star-fill"></i></li>
                    <li><i class="ri-star-fill"></i></li>
                    <li><i class="ri-star-fill"></i></li>
                    <li><i class="ri-star-half-line"></i></li>
                  </ul>
                </div>
              </div>
            </Slide>

            <template #addons>
              <Pagination />
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "OurTestimonials",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    testimonials: [
  {
    "id": 1,
    "shortDesc": "Empresa global líder en cemento, concreto y agregados. La planta de Huichapan, Hidalgo, es clave en la producción de alta calidad en México.",
    "name": "CEMEX Huichapan, Hidalgo",
    "designation": "Cliente satisfecho"
  },
  {
    "id": 2,
    "shortDesc": "Multinacional especializada en sistemas de transmisión automotriz, con plantas en Celaya y Villagrán, Guanajuato.",
    "name": "GKN Celaya y GKN Villagrán",
    "designation": "Cliente satisfecho"
  },
  {
    "id": 3,
    "shortDesc": "Empresa química global que fabrica biocidas y aditivos especializados. Operaciones en Querétaro y San Juan del Río.",
    "name": "Thor Querétaro y Thor San Juan del Río",
    "designation": "Cliente satisfecho"
  },
  {
    "id": 4,
    "shortDesc": "Parque agroindustrial en Querétaro dedicado a la agricultura protegida y exportación de hortalizas de alta calidad.",
    "name": "Agropark",
    "designation": "Cliente satisfecho"
  },
  {
    "id": 5,
    "shortDesc": "Fabricante global de plásticos automotrices con plantas en San Juan del Río y Querétaro, líder en la industria.",
    "name": "ABC San Juan del Río y ABC Querétaro",
    "designation": "Cliente satisfecho"
  },
  {
    "id": 6,
    "shortDesc": "Comercializa láminas metálicas y plásticas para construcción e industria, enfocándose en calidad y soluciones innovadoras.",
    "name": "Lámina",
    "designation": "Cliente satisfecho"
  },
  {
    "id": 7,
    "shortDesc": "Fabricante de piezas plásticas automotrices, reconocido por estándares de calidad y soluciones eficientes.",
    "name": "Michell Plastic",
    "designation": "Cliente satisfecho"
  },
  {
    "id": 8,
    "shortDesc": "Empresa alemana líder en interiores automotrices y asientos para vehículos comerciales y off-road.",
    "name": "Grammer",
    "designation": "Cliente satisfecho"
  },
  {
    "id": 9,
    "shortDesc": "Especialista en transmisiones automotrices avanzadas, destacada en diseño e innovación. Operaciones globales y en México.",
    "name": "Tremec",
    "designation": "Cliente satisfecho"
  }

],
  }),
});
</script>